// extracted by mini-css-extract-plugin
export default {"form":"styles-module__form__src-labstep-web-core-Form-Reusable-_FF2Jh","message":"styles-module__message__src-labstep-web-core-Form-Reusable-_yOZ3i"};